import type { ProductConfig } from '#types/config/components/product'

export default {
  brandClasses: {
    wrapper: 'mt-4 space-y-2 <lg:mb-4'
  },
  dialogOptions: {
    type: 'panel'
  }
} satisfies ProductConfig['shippingMethods']
